module.exports = __webpack_public_path__ + "static/media/banner_right_shap.6ecc6601.png";